export default "__VITE_ASSET__5XbYr4WL__"